export default __webpack_public_path__ + "static/solderingiron-70716a9124ff8478f866e2399262b62a.png";